import * as types from '@/store/types';
import { INote } from '@/entities/note/note.interface';
import * as utils from '@/utils';

interface State {
    notes: INote[];
}

const initialState: State = {
    notes: []
};

const getters = {
    [types.GET_NOTES]: (state: State) => {
        return state.notes;
    }
};

const mutations = {
    [types.ADD_NOTE]: (state: State, payload: INote) => {
        let existIndex = state.notes.findIndex(
            (note) =>
                note.body === payload.body && note.heading === payload.heading
        );

        if (existIndex > -1) {
            state.notes = utils.changeArrayItem(
                state.notes,
                {
                    ...payload,
                    total: state.notes[existIndex].total + 1
                },
                existIndex
            );
        } else {
            state.notes = [payload, ...state.notes];
        }
    },
    [types.REMOVE_NOTE]: (state: State, payload: string) => {
        state.notes = state.notes.filter(
            (note: INote) => note.guid !== payload
        );
    }
};

const actions = {
    [types.ADD_TEMP_NOTE]: ({ commit }, payload: INote) => {
        commit(types.ADD_NOTE, payload);

        setTimeout(() => {
            commit(types.REMOVE_NOTE, payload.guid);
        }, 3000);
    }
};

export default {
    state: initialState,
    mutations,
    actions,
    getters
};
